import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosClient from '../../api/axiosClient';
import { User, AdminStats } from '../../types';

interface UsersState {
  list: User[];
  stats: AdminStats | null;
  status: 'idle' | 'loading' | 'failed';
  error: string | null;
}

const initialState: UsersState = {
  list: [],
  stats: null,
  status: 'idle',
  error: null,
};

export const fetchAllUsers = createAsyncThunk('users/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosClient.get('/admin/users');
    return data.users as User[];
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.message || 'Could not load users');
  }
});

export const fetchAdminStats = createAsyncThunk('users/fetchStats', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosClient.get('/admin/stats');
    return data as AdminStats;
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.message || 'Could not load stats');
  }
});

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      })
      .addCase(fetchAdminStats.fulfilled, (state, action) => {
        state.stats = action.payload;
      });
  },
});

export default usersSlice.reducer;
